import React from 'react';
import { isPickupUrgentForRunType } from '../../utils/collectionTypes';

const CancelView = (props) => {
  let {pickup, run, enterNote, enterCancel, isCancelView, isNoteView,
    reasons, onCancelReason, onLocationAddNote, noteCancelLeave,
    onLocationCancel, isReadOnly} = props;
  let hasCancelReason = pickup.cancelReason != null && pickup.cancelReason != '';
  const isUrgentForThisRun = isPickupUrgentForRunType(pickup, run && run.truckCollectionTypeCode);

  return (
    <div className="form-group">
      {!isCancelView && !isNoteView && hasCancelReason &&
      <div className="row">
        <div className="col-md-12">
          <span><strong>Pickup Note</strong>: {pickup.cancelReason == null ? 'N/A' : pickup.cancelReason}&nbsp;&nbsp;</span>
        </div>
      </div>
      }
      {!isCancelView && !isNoteView && !pickup.isBase && !isReadOnly &&
      <div className="row">
        <div className="col-md-4">
          <button type="button"
                  className="btn btn-primary"
                  onClick={enterNote}>
            {hasCancelReason && 'Edit Note'}
            {!hasCancelReason && 'Add Note'}
          </button>&nbsp;
          {!isUrgentForThisRun && pickup.pickupStatusCode == 'PEN' &&
            <button type="button"
                    className="btn btn-danger"
                    onClick={enterCancel}>
              Cancel
            </button>
          }
        </div>
          {isUrgentForThisRun &&
          <div className="col-md-10">
            <span className="text-danger"><strong><i className="fa fa-exclamation-triangle" />&nbsp;Urgent job to cancel call <a href="tel:0295444323">Office</a> or <a href="tel:0425218073">Scheduler</a></strong></span>
          </div>
          }
      </div>
      }
      {(isNoteView || isCancelView) && !pickup.isBase && !isReadOnly &&
      <div className="row">
        <div className="input-group">
          <div className="input-group-btn">
            <button type="button"
                    className="btn btn-primary dropdown-toggle"
                    data-toggle="dropdown">Reasons<span className="caret" />
            </button>
            <div className="dropdown-menu">
              {[...reasons].map(x => {
                return (<a className="dropdown-item"
                           onClick={(e) => onCancelReason(e, pickup.id, x)}
                           href="#" key={x}>{x}</a>);
              })}
            </div>
          </div>
          <textarea type="text"
                    className="form-control"
                    placeholder="Own reason"
                    value={pickup.cancelReason == null ? '' : pickup.cancelReason}
                    onChange={(e) => onCancelReason(e, pickup.id)}
          />
          <div className="input-group-btn">
            { isNoteView &&
            <button type="button"
                    className="btn btn-primary"
                    onClick={(e) => onLocationAddNote(e, run.id, pickup.id)}
            ><i className="fa fa-check" /></button>
            }
            { isCancelView &&
            <button type="button"
                    className="btn btn-primary"
                    onClick={(e) => onLocationCancel(e, run.id, pickup.id)}
            ><i className="fa fa-check" /></button>
            }
            <button type="button"
                    className="btn btn-default"
                    onClick={noteCancelLeave}
            ><i className="fa fa-times" /></button>
          </div>
        </div>
      </div>}

    </div>);

};

export default CancelView;